import React, { useState, useEffect, useRef } from "react";
import "../../../6729.css";

// Front and Back Images for FF6724

import image1 from "../../../images/Engine-car/synthetic/6726/pictures_FF6726-1_green_front_1200.jpg";
import image2 from "../../../images/Engine-car/synthetic/6726/pictures_FF6726-1_green_back_1200.jpg";

import image3 from "../../../images/Engine-car/synthetic/6726/pictures_FF6726-5_green_front_1200.jpg";
import image4 from "../../../images/Engine-car/synthetic/6726/pictures_FF6726-5_green_back_1200.jpg";

import image5 from "../../../images/Engine-car/synthetic/6726/pictures_FF6726-20_green_front_1200.jpg";
import image6 from "../../../images/Engine-car/synthetic/6726/pictures_FF6726-20_green_back_1200.jpg";

import image7 from "../../../images/Engine-car/synthetic/6726/pictures_FF6726-DR_green_front_1200.jpg";
import image8 from "../../../images/Engine-car/synthetic/6726/pictures_FF6726-DR_green_back_1200.jpg";



const images = [
  { src: image1, alt: "Front" },
  { src: image3, alt: "Back" },
  { src: image5, alt: "Front 4L" },
  { src: image7, alt: "Back 4L" },

];

const packageSlides = [
  { images: [image1, image2] },
  { images: [image3, image4] },
  { images: [image5, image6] },   // 1L
  { images: [image7, image8] }   // 20L


];

const TDS_URL = "https://www.fanfaro.de/create-pdf/147";

const SDS_FILES = [
  { code: "BE", url: "https://sct-b2b.com/out/msds/sdFF6726_-_FANFARO 6726 XTR 0W-30_(BE).pdf" },
  { code: "BG", url: "https://sct-b2b.com/out/msds/sdFF6726_-_FANFARO 6726 XTR 0W-30_(BG).pdf" },
  { code: "CZ", url: "https://sct-b2b.com/out/msds/sdFF6726_-_FANFARO 6726 XTR 0W-30_(CZ).pdf" },
  { code: "DE", url: "https://sct-b2b.com/out/msds/sdFF6726_-_FANFARO 6726 XTR 0W-30_(DE).pdf" },
  { code: "DK", url: "https://sct-b2b.com/out/msds/sdFF6726_-_FANFARO 6726 XTR 0W-30_(DK).pdf" },
  { code: "EE", url: "https://sct-b2b.com/out/msds/sdFF6726_-_FANFARO 6726 XTR 0W-30_(EE).pdf" },
  { code: "ES", url: "https://sct-b2b.com/out/msds/sdFF6726_-_FANFARO 6726 XTR 0W-30_(ES).pdf" },
  { code: "FI", url: "https://sct-b2b.com/out/msds/sdFF6726_-_FANFARO 6726 XTR 0W-30_(FI).pdf" },
  { code: "FR", url: "https://sct-b2b.com/out/msds/sdFF6726_-_FANFARO 6726 XTR 0W-30_(FR).pdf" },
  { code: "GR", url: "https://sct-b2b.com/out/msds/sdFF6726_-_FANFARO 6726 XTR 0W-30_(GR).pdf" },
  { code: "HR", url: "https://sct-b2b.com/out/msds/sdFF6726_-_FANFARO 6726 XTR 0W-30_(HR).pdf" },
  { code: "HU", url: "https://sct-b2b.com/out/msds/sdFF6726_-_FANFARO 6726 XTR 0W-30_(HU).pdf" },
  { code: "IE (EN)", url: "https://sct-b2b.com/out/msds/sdFF6726_-_FANFARO 6726 XTR 0W-30_(IE).pdf" },
  { code: "IT", url: "https://sct-b2b.com/out/msds/sdFF6726_-_FANFARO 6726 XTR 0W-30_(IT).pdf" },
  { code: "LT", url: "https://sct-b2b.com/out/msds/sdFF6726_-_FANFARO 6726 XTR 0W-30_(LT).pdf" },
  { code: "LV", url: "https://sct-b2b.com/out/msds/sdFF6726_-_FANFARO 6726 XTR 0W-30_(LV).pdf" },
  { code: "NO", url: "https://sct-b2b.com/out/msds/sdFF6726_-_FANFARO 6726 XTR 0W-30_(NO).pdf" },
  { code: "PL", url: "https://sct-b2b.com/out/msds/sdFF6726_-_FANFARO 6726 XTR 0W-30_(PL).pdf" },
  { code: "PT", url: "https://sct-b2b.com/out/msds/sdFF6726_-_FANFARO 6726 XTR 0W-30_(PT).pdf" },
  { code: "RO", url: "https://sct-b2b.com/out/msds/sdFF6726_-_FANFARO 6726 XTR 0W-30_(RO).pdf" },
  { code: "RU", url: "https://sct-b2b.com/out/msds/sdFF6726_-_FANFARO 6726 XTR 0W-30_(RU).pdf" },
  { code: "SE", url: "https://sct-b2b.com/out/msds/sdFF6726_-_FANFARO 6726 XTR 0W-30_(SE).pdf" },
  { code: "SI", url: "https://sct-b2b.com/out/msds/sdFF6726_-_FANFARO 6726 XTR 0W-30_(SI).pdf" },
  { code: "SK", url: "https://sct-b2b.com/out/msds/sdFF6726_-_FANFARO 6726 XTR 0W-30_(SK).pdf" }
];

export default function ImageWithContent() {

  const [currentIndex, setCurrentIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [showSDS, setShowSDS] = useState(false);

  const [packageIndex, setPackageIndex] = useState(0);
  const [imageIndex, setImageIndex] = useState(0);

  const slideInterval = useRef(null);
  const slideDuration = 4000;

  useEffect(() => {
    startSlideTimer();
    return () => clearInterval(slideInterval.current);
  }, []);

  const startSlideTimer = () => {
    slideInterval.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, slideDuration);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
    clearInterval(slideInterval.current);
    startSlideTimer();
  };

  const nextImage = () => {
    const total = packageSlides[packageIndex].images.length;
    setImageIndex((prev) => (prev + 1) % total);
  };

  const prevImage = () => {
    const total = packageSlides[packageIndex].images.length;
    setImageIndex((prev) => (prev === 0 ? total - 1 : prev - 1));
  };

  return (
    <>
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "center",
        gap: "32px",
        padding: "24px",
        fontFamily: "Arial",
      }}
    >

      {/* LEFT IMAGE CAROUSEL */}
       <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>

        {/* IMAGE CAROUSEL */}
        <div
          style={{
            position: "relative",
            width: "300px",
            height: "400px",
            borderRadius: "8px",
            overflow: "hidden",
          }}
        >
          {images.map((img, index) => (
            <img
              key={index}
              src={img.src}
              alt={img.alt}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                position: index === currentIndex ? "relative" : "absolute",
                opacity: index === currentIndex ? 1 : 0,
                transition: "opacity 1s",
              }}
            />
          ))}
        </div>
        <p
          style={{
            // marginTop: "15px",
            fontSize: "14px",
            color: "#0c0c0c",
            textAlign: "justify",
            lineHeight: "1.6",
            width:"250px",
            fontSize:"12px"
          }}
        >
          Attention! The packaging is illustrative and may differ from its actual appearance. For the latest list of specifications, see the text section.
        </p>


        
        {/* Amazon Button (external link) */}
        <a
          href="https://amzn.in/d/00uQ72xo"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <button
            style={{
              width: "150px",
              padding: "12px",
              backgroundColor: "#0d4d33",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              fontSize: "16px",
              cursor: "pointer",
            }}
          >
            Buy on Amazon
          </button>
        </a>

      </div>

      {/* RIGHT CONTENT */}
      <div style={{ paddingLeft: "30px", maxWidth: "850px" }}>
        <h2>FANFARO XTR 0W-30 6726</h2>

        <p>
          Premium PAO-based engine oil for modern diesel- and petrol-powered engines of vehicles produced by European manufacturers with and without a turbocharger.
        </p>

        <p><strong>Product properties:</strong></p>

        <ul style={{ paddingLeft: "20px" }}>
          
          <li>Exceptional fuel savings due to reduced HTHS viscosity and optimized anti-friction properties.</li>
          <li>Low-viscosity bi-synthetic base (PAO + esters) with a high-efficiency additive package ensures reliable cold starts in the harshest conditions, reducing engine startup wear.</li>
          <li>Excellent cleaning and dispersing properties, combined with high thermo-oxidative stability, effectively prevent deposits and keep engine and turbocharger components clean throughout the oil replacement interval.</li>
          <li>Ester components provide outstanding anti-wear protection thanks to a strong oil film and excellent pumpability, extending engine life even in start-stop driving conditions.</li>
          <li>Compatible with all exhaust gas neutralization systems (DPF, TWC, EGR, SCR) due to Mid SAPS technology.</li>
          <li>Suitable for engines with extended oil change intervals (Long Life up to 30,000 km) as well as conventional intervals.</li>
          <li>The modern additive package combined with the bi-synthetic base maintains engine power throughout the entire oil replacement period.</li>
          <li>Designed for diesel and petrol engines in MERCEDES-BENZ, FORD, JAGUAR, and LAND ROVER passenger cars, light SUVs, and light trucks requiring additional manufacturer-specific specifications or API SN / ACEA C2/C3 performance for this viscosity class.</li>
          <li>Not suitable for heavy trucks or similar large vehicles.</li>
        </ul>

        <p style={{ color: "#4CAF50", fontWeight: "bold" }}>
          CORRESPONDS WITH REQUIREMENTS / SPECIFICATIONS / PRODUCTS:
        </p>

        {/* SPECIFICATIONS */}
        <div style={{ display: "flex", gap: "40px", flexWrap: "wrap" }}>
          <div>
            <b>Specifications</b>
            <ul style={{ paddingLeft: "20px" }}>
              <li>SAE 0W-30</li>
              <li>API SN Plus</li>
              <li>ACEA C2</li>
              <li>API SP</li>
            </ul>
          </div>


          <div>
            <b>Recommendation</b>
            <ul style={{ paddingLeft: "20px" }}>
              <li>BMW LL-12FE</li>
              <li>MB 229.61</li>
              <li>FORD WSS-M2C950-A</li>
              <li>PSA B71 2290</li>
              <li>PSA B71 2312</li>
              <li>ACEA C3</li>
              <li>OPEL OV0401547</li>
            </ul>
          </div>

          <div>
            <b>PACKAGES:</b>
            <ul style={{ paddingLeft: "20px" }}>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(0);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  1L (FF6726-1)
                </span>
              </li>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(1);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  5L (FF6726-5)
                </span>
              </li>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(2);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  20L (FF6726-20)
                </span>
              </li>

              

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(3);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  208L (FF6726-DR)
                </span>
              </li>


            </ul>
          </div>
          <div>
            <b>SDS & TDS</b>
            <ul style={{ paddingLeft: "20px" }}>

              <li>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowSDS(true);
                  }}
                  style={{ textDecoration: "none", cursor: "pointer" }}
                >
                  📄 SDS
                </a>
              </li>

              <li>
                <a
                  href={TDS_URL}
                  target="_blank"
                  style={{ textDecoration: "none" }}
                >
                  🖨️ TDS
                </a>
              </li>

            </ul>
          </div>

        </div>

        {/* PACKAGES */}
        {/* <p style={{ marginTop: "20px", fontWeight: "bold" }}>
          PACKAGES (ARTICLE NUMBER):
        </p>

        <ul style={{ paddingLeft: "20px" }}>

          <li>
            <span
              style={{cursor: "pointer" }}
              onClick={() => {
                setPackageIndex(0);
                setImageIndex(0);
                setShowModal(true);
              }}
            >
              20L (FF6201-1)
            </span>
          </li>

          <li>
            <span
              style={{ cursor: "pointer" }}
              onClick={() => {
                setPackageIndex(1);
                setImageIndex(0);
                setShowModal(true);
              }}
            >
              60L (FF6201-20)
            </span>
          </li>

          <li>
            <span
              style={{ cursor: "pointer" }}
              onClick={() => {
                setPackageIndex(2);
                setImageIndex(0);
                setShowModal(true);
              }}
            >
              208L (FF6201-60)
            </span>
          </li>

          <li>
            <span
              style={{cursor: "pointer" }}
              onClick={() => {
                setPackageIndex(3);
                setImageIndex(0);
                setShowModal(true);
              }}
            >
              1000L (FF6201-DR)
            </span>
          </li>

        </ul> */}
      </div>

      {/* MODAL */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "20px",
              width: "500px",
              borderRadius: "8px",
              position: "relative",
            }}
          >

            <span
              onClick={() => setShowModal(false)}
              style={{
                position: "absolute",
                right: "15px",
                top: "10px",
                cursor: "pointer",
                fontSize: "22px",
              }}
            >
              ✕
            </span>

            <img
              src={packageSlides[packageIndex].images[imageIndex]}
              alt="package"
              style={{
                width: "100%",
                maxHeight: "450px",
                objectFit: "contain",
              }}
            />

            <div style={{ textAlign: "center", marginTop: "20px" }}>

              <button onClick={prevImage}>◀</button>

              <span style={{ margin: "0 15px" }}>
                {imageIndex + 1} of {packageSlides[packageIndex].images.length}
              </span>

              <button onClick={nextImage}>▶</button>

            </div>

          </div>
        </div>
      )}

      {showSDS && (
        <div className="sds-overlay" onClick={() => setShowSDS(false)}>
          <div className="sds-modal" onClick={(e) => e.stopPropagation()}>
            {/* Close Icon */}
            <button
              className="sds-close-icon"
              onClick={() => setShowSDS(false)}
              aria-label="Close SDS"
            >
              ×
            </button>

            <h3>SDS – FANFARO 6726</h3>

            <div className="sds-grid">
              {SDS_FILES.map((file) => (
                <a
                  key={file.code}
                  href={file.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {file.code}
                </a>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>

    <a
        href="https://wa.me/7204731100?text=Hello%20I%20need%20details"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
          alt="WhatsApp"
        />
      </a>
    </>
  );
}



